import store from '../../../../store'
import { routes as api } from '../../../../plugins/api'

export default {
  updatePatientHeight(questionKey) {
    return async () => {
      const patientId = store.getters['newAttendanceForm/patientData'].id
      const value = store.getters['newAttendanceForm/answers'][questionKey]
      const parsedValue = Number(value) * 100
      await api.partialUpdatePatient({ id: patientId, currentHeightCm: parsedValue })
      store.commit('newAttendanceForm/updatePatientData', { height: parsedValue })
    }
  },
  updatePatientWeight(questionKey) {
    return async () => {
      const patientId = store.getters['newAttendanceForm/patientData'].id
      const value = store.getters['newAttendanceForm/answers'][questionKey]
      const parsedValue = Number(value)
      await api.partialUpdatePatient({ id: patientId, currentWeightKg: parsedValue })
      store.commit('newAttendanceForm/updatePatientData', { weight: parsedValue })
    }
  },
}
